module.exports = {
	"header": "Mot de passe & sécurité",
	"changePassword": "Modifier le mot de passe",
	"createPassword": "Créer un mot de passe",
	"createPasswordText": "Créer un mot de passe vous permettant de vous connecter avec votre nom d'utilisateur et un mot de passe.",
	"currentPassword": "Mot de passe actuel",
	"newPassword": "Nouveau mot de passe",
	"password": "Mot de passe",
	"pwFieldEmpty": "Champ vide. Vous devez fournir un mot de passe.",
	"pwNotIdentical": "Les mots de passe fournis ne sont pas les mêmes.",
	"pwsGood": "Bon",
	"pwsStrong": "Fort",
	"pwsTooWeak": "Trop faible",
	"pwsVeryStrong": "Très fort",
	"pwsWeak": "Faible",
	"pwTooShort": "Le mot de passe fourni est trop court. Il doit être de 8 caractères ou plus.",
	"repeatNewPassword": "Répétez le nouveau mot de passe",
	"forgotPw": {
		"emailSent": "Un courriel contenant un lien pour réinitialiser votre mot de passe a été envoyé à cette adresse",
		"errorNoAccount": "Aucun compte n'est associé à cette adresse courriel",
		"errorNoPassword": "Aucun mot de passe n'est associé à cette adresse courriel",
		"errorSocial": "Ce courriel est associé à un compte externe. Veuillez vous connecter à l'aide d'une des méthodes suivantes: __socialAccounts__.",
		"header": "Mot de passe oublié?",
		"repeatPassword": "Répétez le mot de passe",
		"request": "Une réinitialisation de mot de passe pour le compte __brand__ associé à l'adresse __userEmail__ a été demandée.",
		"textLn1": "Entrez votre courriel pour réinitialiser votre mot de passe:"
	},
	"resetPw": {
		"errorEmpty": "S'il vous plaît, entrez un nouveau mot de passe. Les champs ne peuvent pas être vides.",
		"errorLinkNotValid": "Ce n'est pas un lien de réinitialisation de mot de passe valide.",
		"errorNotIdentical": "Les mots de passe fournis ne sont pas les mêmes.",
		"newPassword": "Nouveau mot de passe:",
		"success": "Le mot de passe est réinitialisé. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
		"repeatNewPassword": "Répétez le nouveau mot de passe:",
		"resetPassword": "Réinitialiser le mot de passe",
		"header": "Réinitialisation de mot de passe"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/password.json5
// module id = 2001
// module chunks = 6